import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import "../../index.css";
import ViewIcon from "../../assets/icon/ViewIcon.svg";
import DeleteIcon from "../../assets/icon/deleteIcon.svg";
import EditIcon from "../../assets/icons/edit.svg";
import ProfileImage from "../../assets/images/profileImage.svg";
import BlockModel from "../common/BlockModel";
import ShiftTable from "../../components/common/table";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { deleteShiftDuty, } from "../../features/shift/shiftSlice";
import { deleteShiftDutyDTO } from "../../dtos/shift";
import { Roles, ShiftTypes } from "../../utils/constants";
import { ShiftHeader } from "../../utils/headers";
import { getLatestCheckInCheckout, computeShiftStatus } from "../../utils/utils";
import { AssignShiftModel } from "./assign-shift-model";
import { styles } from "./styles";
import { SHIFTMANAGEMENT_DASHBOARD_USER_SCREEN_ROUTE } from "../../routes";
import { useNavigate } from "react-router-dom";
import { resetFlags } from '../../features/shift/shiftSlice';  // Adjust the path accordingly
import { useCallback, useEffect, useState } from "react";
import AppSnackbar from "../../components/common/AppSnackbar";

interface IProps {
  clinicId: string;
  requiredFilters: any;
  setDropDownValues: any;
  getAllShifts?: any;
  searchQuery?: string;
  renderActions?: any; // Include renderActions
  staffMembers?: any;
  employeeNames?: any;
  apiData?: any;
  activityData?: any;
}

const AllShift = ({
  clinicId,
  requiredFilters,
  setDropDownValues,
  getAllShifts,
  searchQuery,
  renderActions, // Changed from renderActions to renderActionsComponent
  staffMembers,
  employeeNames,
  apiData,
  activityData
}: IProps) => {

  const [filterData, setFilterData] = useState<any>([]);
  useEffect(() => {
    const initialData = apiData?.staff_duty_with_roles?.map((item: any) => {
      const check_in = getLatestCheckInCheckout(item?.pharmacyStaff?.id, activityData?.acitvity)?.latestCheckIn;
      const check_out = getLatestCheckInCheckout(item?.pharmacyStaff?.id, activityData?.acitvity)?.latestCheckOut;
      return {
        name: item?.pharmacyStaff?.name,  // Get pharmacy staff name or fallback
        role_id: item?.pharmacyStaff?.role?.role,
        avatar: ProfileImage,  // Avatar, fallback if missing
        shift_type: ShiftTypes[(item?.shift_type)].charAt(0).toUpperCase() + ShiftTypes[(item?.shift_type)].slice(1).toLowerCase() + " Shift",  // Shift type or fallback
        timings: `${item?.start_time}-${item?.end_time}`,  // Shift timings
        start_time: item?.start_time,  // Start time
        end_time: item?.end_time,  // End time
        address: item?.pharmacyStaff?.address,  // Address of the pharmacy staff
        shift_status: computeShiftStatus(item?.start_time, item?.end_time, check_in, check_out),  // Shift status
        id: item?.id,  // Unique ID for this entry
        date: item?.updated_at,  // Date of shift or fallback
        email: item?.pharmacyStaff?.email,  // Email of pharmacy staff
        phone_number: item?.pharmacyStaff?.phone_number,  // Phone number, fallback
        staff_id: item?.pharmacyStaff?.id,  // Staff ID
        last_login: item?.last_login,  // Last login time, fallback
        off_day: item?.off_day,  // Off day
      };
    });
    
    setFilterData(initialData);
  }, [apiData, activityData]);

  const [currentName, setCurrentName] = useState("");
  const [currentID, setCurrentID] = useState(-1);
  const [currentStaffID, setCurrentStaffID] = useState(-1);
  const [open, setOpen] = useState(false);
  const [showAlert, setShowAlert] = useState(false);  // State for showing alert
  const [openShiftEditModel, setOpenShiftEditModel] = useState(false);
  const dispatch = useAppDispatch();
  const [dataForEditMember, setDataForEditMember] = useState<any>({});
  const {
    isDeleteShiftDutySuccess,
    isAddShiftDutySuccess,
    isUpdateShiftDutySuccess,
    isAddShiftDutyError,
    isUpdateShiftDutyError,
    isDeleteShiftDutyError

  }: any = useAppSelector((state) => state.shift);
  const deleteShift = useCallback((object: deleteShiftDutyDTO) => {
    dispatch(deleteShiftDuty(object));
  }, [dispatch]);
  const navigate = useNavigate();
  const shiftTypes = ["Morning", "Evening", "Night"];
  const shiftStatus = ["Completed", "In Progress", "Absent", "Upcoming"];
  const shiftMembersNames = Array.from(new Set(staffMembers?.map((item: any) => item?.staff?.name)))
  const uniqueRoles = Array.from(
    new Set(
      staffMembers?.map((item: any) => String(item.credentials?.role)) // Extract unique roles as strings
    )
  ) as string[];
  const mappedRoles = uniqueRoles.map((role: any) => {
    const roleName = Roles[role];
    return roleName.charAt(0).toUpperCase() + roleName.slice(1).toLowerCase();
  });
  const dropDownOptions = {
    EmployeeName: shiftMembersNames,
    Role: mappedRoles,
    ShiftType: shiftTypes,
    ShiftStatus: shiftStatus,
  };
  const handleOpen = (item: any) => {
    setCurrentName(item.name);
    setCurrentID(item.id);
    setCurrentStaffID(item.staff_id);
    setOpen(true);
  };
  const handleView = (item: any) => {
    navigate(SHIFTMANAGEMENT_DASHBOARD_USER_SCREEN_ROUTE.replace(':userId', item?.staff_id));
  };
  const handleClose = () => {
    setOpen(false);
    setCurrentName("");
    setCurrentID(-1);
    setCurrentStaffID(-1);
  };
  const handleOpenShiftEditModel = (item: any) => {
    const object = {
      staffMember: { name: item.name, id: item.staff_id },
      shiftType: item.shift_type,
      startTime: item.start_time?.split("-")[0]?.trim(),
      startTimePeriod: item.start_time?.split("-")[0]?.trim()?.split(" ")[1],
      endTime: item.end_time?.split("-")[0]?.trim(),
      endTimePeriod: item.end_time?.split("-")[0]?.trim()?.split(" ")[1],
      offDays: item?.off_day,
      dutyID: item?.id,
    }
    setDataForEditMember(object);
    setOpenShiftEditModel(true);
  }
  const handleCloseShiftEditModel = () => {
    setOpenShiftEditModel(false);
  };
  const handleBlock = () => {
    // Close the modal and show alert for 3 seconds
    //const pharmacyID = Number(localStorage?.getItem("pharmacyId"));
    deleteShift({ id: currentID, staff_id: currentStaffID });
    handleClose();
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);  // Hide the alert after 4 seconds
    }, 3500);
  };

  const renderActionsComponent = (item: any) => (
    <Box sx={styles.actionBox}>
      <Tooltip title="View User">
        <Box
          component="img"
          src={ViewIcon}
          style={styles.icon}
          alt="view"
          onClick={() => handleView(item)}
        />
      </Tooltip>
      <Tooltip title="Edit Shift">
        <Box
          component="img"
          src={EditIcon}
          style={styles.icon}
          onClick={() => handleOpenShiftEditModel(item)}
          alt="edit"

        />
      </Tooltip>
      <Tooltip title="Delete Shift">
        <Box
          component="img"
          src={DeleteIcon}
          style={styles.icon}
          alt="RedAlert"
          onClick={() => handleOpen(item)}
        />
      </Tooltip>
    </Box>
  );


  useEffect(() => {
    setDropDownValues(dropDownOptions);

    const filterDataFunction = ({
      dropdown1,
      date,
      dropdown2,
      dropdown3,
      dropdown4,
    }: any) => {
      return apiData?.staff_duty_with_roles?.map((item: any) => {
        const check_in = getLatestCheckInCheckout(item?.pharmacyStaff?.id, activityData?.acitvity)?.latestCheckIn;
        const check_out = getLatestCheckInCheckout(item?.pharmacyStaff?.id, activityData?.acitvity)?.latestCheckOut;
        const matchSearch = searchQuery
          ? item.pharmacyStaff?.name.toLowerCase().includes(searchQuery.toLowerCase()) || Roles[item?.pharmacyStaff?.role?.role]?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          ShiftTypes[item.shift_type]?.toLowerCase().includes(searchQuery.toLowerCase())
          : true;
        const matchesName = dropdown1
          ? item.pharmacyStaff?.name.toLowerCase().includes(dropdown1.toLowerCase())
          : true;
        // const matchesDate = date ? item.updated_at.includes(date) : true;
        const matchesRole = dropdown2
          ? Roles[item?.pharmacyStaff?.role?.role]?.toLowerCase() === (dropdown2)?.toLowerCase()
          : true;
        const matchesShiftType = dropdown3 ? ShiftTypes[item.shift_type]?.toLowerCase() === dropdown3?.toLowerCase() : true;
        const matchesShiftStatus = dropdown4 ? computeShiftStatus(item?.start_time, item?.end_time, check_in, check_out) === dropdown4 : true;

        if (matchSearch && matchesName && matchesRole && matchesShiftType && matchesShiftStatus) {
          const check_in = getLatestCheckInCheckout(item?.pharmacyStaff?.id, activityData?.acitvity)?.latestCheckIn;
          const check_out = getLatestCheckInCheckout(item?.pharmacyStaff?.id, activityData?.acitvity)?.latestCheckOut;

          return {
            name: item?.pharmacyStaff?.name || "",  // Get pharmacy staff name or fallback
            role_id: item?.pharmacyStaff?.role?.role
              ? item?.pharmacyStaff?.role?.role
              : "",
            avatar: ProfileImage,  // Avatar, fallback if missing
            shift_type: ShiftTypes[item?.shift_type]
              ? ShiftTypes[item?.shift_type].charAt(0).toUpperCase() + ShiftTypes[item?.shift_type].slice(1).toLowerCase() + " Shift"
              : "",  // Shift type or fallback
            timings: `${item?.start_time}-${item?.end_time}`,  // Shift timings
            start_time: item?.start_time,  // Start time
            end_time: item?.end_time,  // End time
            address: item?.pharmacyStaff?.address || "",  // Address of the pharmacy staff
            shift_status: computeShiftStatus(item?.start_time, item?.end_time, check_in, check_out),  // Shift status
            id: item?.id,  // Unique ID for this entry
            date: item?.updated_at,  // Date of shift or fallback
            email: item?.pharmacyStaff?.email || "",  // Email of pharmacy staff
            phone_number: item?.pharmacyStaff?.phone_number || "",  // Phone number, fallback
            staff_id: item?.pharmacyStaff?.id,  // Staff ID
            last_login: item?.last_login,  // Last login time, fallback
            off_day: item?.off_day,  // Off day
          };
        }

        return null;  // Return null if the filter condition is not met
      }).filter((item: any) => item !== null && item);  // Remove any null entries from the final result
    };

    const filteredData = filterDataFunction(requiredFilters);
    setFilterData(filteredData ? filteredData : []);
  }, [clinicId, requiredFilters, setDropDownValues, searchQuery]);

  useEffect(() => {
    // Show the alert only once for a successful operation
    if (isAddShiftDutySuccess || isUpdateShiftDutySuccess || isDeleteShiftDutySuccess || isDeleteShiftDutyError || isAddShiftDutyError || isUpdateShiftDutyError || isDeleteShiftDutyError) {
      if (isUpdateShiftDutySuccess || isUpdateShiftDutyError) {
        setOpenShiftEditModel(false);
      }
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
        dispatch(resetFlags());
      }, 3500);  // Hide alert after 4 seconds
    }
  }, [isAddShiftDutySuccess, isUpdateShiftDutySuccess, isDeleteShiftDutySuccess, isUpdateShiftDutyError, isDeleteShiftDutyError, isAddShiftDutyError, dispatch]);
  return (
    <>
      <AppSnackbar
        message={isDeleteShiftDutySuccess ? "Shift Deleted Successfully" : isDeleteShiftDutyError && "Unable to Block"}
        open={showAlert && (isDeleteShiftDutySuccess || isDeleteShiftDutyError)}
        handleClose={() => setShowAlert(false)}
        severity={isDeleteShiftDutySuccess ? "success" : isDeleteShiftDutyError ? "error" : "success"}
      />
      <AppSnackbar
        message={isUpdateShiftDutySuccess ? "Shift Updated Successfully" : isUpdateShiftDutyError && "Unable to Update"}
        open={showAlert && (isUpdateShiftDutySuccess || isUpdateShiftDutyError)}
        handleClose={() => setShowAlert(false)}
        severity={isUpdateShiftDutySuccess ? "success" : isUpdateShiftDutyError ? "error" : "success"}
      />
      <AppSnackbar
        message={isAddShiftDutySuccess ? "Shift Added Successfully" : isAddShiftDutyError && "Unable to Add"}
        open={showAlert && (isAddShiftDutySuccess || isAddShiftDutyError)}
        handleClose={() => setShowAlert(false)}
        severity={isAddShiftDutySuccess ? "success" : isAddShiftDutyError ? "error" : "success"}
      />
      <ShiftTable headers={ShiftHeader} data={filterData ? [...filterData].reverse() : null} Actions={renderActionsComponent} profilePictureHeight={15} profilePictureWidth={14} />
      <BlockModel open={open} onClose={handleClose} heading={"Delete Shift for " + currentName + "?"} blockText={"Delete"} subheading={"Are you sure you want to Delete this Shift?"} currentName={currentName} onBlock={handleBlock} />
      <AssignShiftModel title="Update Shift" open={openShiftEditModel} editMode={true} editMember={dataForEditMember} listMembers={employeeNames} handleClose={handleCloseShiftEditModel} />
    </>
  );
};

export default AllShift;
